import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-white overflow-hidden" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-15">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:w-1/2" data-id="element-16">
            <h2 className="text-gold font-sans uppercase tracking-[0.2em] font-semibold text-sm mb-4" data-id="element-17">
              About Compass Moving
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-navy font-bold mb-6 leading-tight" data-id="element-18">
              Moving with Direction, Integrity, and Excellence.
            </h3>

            <div className="space-y-8 text-gray-dark/80 text-lg mb-10" data-id="element-19">
              <p data-id="element-20">
                A compass represents direction, trust, and guidance. At Compass
                Moving, these values shape everything we do. We help families
                and businesses transition into new chapters with
                professionalism, care, and attention to every detail.
              </p>
              <p data-id="element-21">
                Based in Dallas, Texas, and serving customers nationwide, we
                believe moving is more than transporting belongings—it's helping
                people move forward. We treat every home, memory, and possession
                with the same care and respect as if they were our own.
              </p>
            </div>

            <ul className="space-y-5 mb-10" data-id="element-22">
              {['Dallas, TX Based with Nationwide Reach', 'Residential & Commercial Moving Services', 'Commitment to Integrity and Excellence', 'Fully Licensed, Bonded & Insured'].map((item, i) => <li key={i} className="flex items-center gap-3 text-navy font-medium" data-id="element-23">
                  <CheckCircle2 className="text-gold w-5 h-5 flex-shrink-0" data-id="element-24" />
                  <span data-id="element-25">{item}</span>
                </li>)}
            </ul>

            <div className="grid grid-cols-3 gap-6 border-t border-gray-200 pt-8" data-id="element-26">
              <div data-id="element-27">
                <div className="text-3xl font-serif font-bold text-navy mb-1" data-id="element-28">
                  50
                </div>
                <div className="text-sm text-gray-dark/70 uppercase tracking-wider font-medium" data-id="element-29">
                  States Served
                </div>
              </div>
              <div data-id="element-30">
                <div className="text-3xl font-serif font-bold text-navy mb-1" data-id="element-31">
                  10k+
                </div>
                <div className="text-sm text-gray-dark/70 uppercase tracking-wider font-medium" data-id="element-32">
                  Successful Moves
                </div>
              </div>
              <div data-id="element-33">
                <div className="text-3xl font-serif font-bold text-navy mb-1" data-id="element-34">
                  15+
                </div>
                <div className="text-sm text-gray-dark/70 uppercase tracking-wider font-medium" data-id="element-35">
                  Years Exp.
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:w-1/2 relative" data-id="element-36">
            <div className="relative rounded-lg overflow-hidden shadow-2xl" data-id="element-37">
              <img src="https://cdn.magicpatterns.com/uploads/1hB6aUphdG535ErVaKuj37/26606380-E7DE-47F2-8BB0-0DC00921B784.png" alt="Compass Moving truck and crew arriving at a beautiful home" className="w-full h-[600px] object-cover" data-id="element-38" />
              <div className="absolute inset-0 bg-navy/10" data-id="element-39" />

              {/* Floating Badge */}
              <div className="absolute bottom-8 left-8 bg-white p-6 rounded shadow-xl max-w-xs border-l-4 border-gold" data-id="element-40">
                <p className="font-serif text-navy font-bold text-xl mb-2" data-id="element-41">
                  "More Than Moving Boxes—We're Moving Lives Forward."
                </p>
                <p className="text-sm text-gray-dark/70" data-id="element-42">
                  — The Compass Moving Team
                </p>
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -z-10 -top-6 -right-6 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-43" />
          </motion.div>
        </div>
      </div>
    </section>;
}